import React from "react";
import { Form, Col } from "react-bootstrap";
import { daysPerspectives } from "../constants";

export default function PerspectivePicker({ formData, setFormData, name, includeCustom = true }) {
    // Check if formData.perspective matches any existing option
    const isCustom = !daysPerspectives.some(x => JSON.stringify(x.days) === formData.perspective);

    return (
        <Form.Group as={Col} controlId={`${name}-perspective`} className="col-12 col-xl-2 min-w-perspective">
            <Form.Label>Perspective</Form.Label>
            <Form.Select value={isCustom ? "custom" : formData.perspective} onChange={e => setFormData({ ...formData, perspective: e.target.value })}>
                {daysPerspectives.map(x => (
                    <option key={x.perspective} value={JSON.stringify(x.days)}>
                        {x.perspective}
                    </option>
                ))}
                {includeCustom && <option value={"custom"}>Custom</option>}
            </Form.Select>
        </Form.Group>
    );
}
